/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Joor_OrdersInputs */

const en_nav_joor_orders = /** @type {(inputs: Nav_Joor_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders from Joor`)
};

/**
* | output |
* | --- |
* | "Orders from Joor" |
*
* @param {Nav_Joor_OrdersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_joor_orders = /** @type {((inputs?: Nav_Joor_OrdersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Joor_OrdersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_joor_orders(inputs)
});